import {INewErrorCode, IErrorCode} from "../../../models/iErrorCode";
import {appAPI} from "../../../api";

const errorCodePath = `/error_code`;

export const errorCodeAPI = {
    add: async (errorCodes: INewErrorCode[]) => {
        try {
            const res = await appAPI.post(errorCodePath, errorCodes);
            return res.data;
        } catch (error: any) {
            const message =
                error.response?.data?.message ||
                error.response?.data?.detail ||
                `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`;
            throw new Error(message);
        }
    },
    getAll: async (params?: { page?: number; limit?: number; search?: string }) => {
        const res = await appAPI.get(errorCodePath, { params });
        return res.data;
    },
    update: async (errorCode: IErrorCode) => {
        try {
            const res = await appAPI.put(`${errorCodePath}/${errorCode.id}/`, {
                ...errorCode,
            });
            return res.data;
        } catch (error: any) {
            const message =
                error.response?.data?.message ||
                error.response?.data?.detail ||
                `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`;
            throw new Error(message);
        }
    },
    delete: async (error_code_id: string) => {
        const res = await appAPI.delete(`${errorCodePath}/${error_code_id}`);
        return res.data;
    },
};
